import React from "react";
import Accordion from "react-bootstrap/Accordion";

const SimAccordion = ({
  children,
  defaultActiveKey = null,
  checkbox,
  button,
  avatar,
  haveMoreDropdown = true,
  nestedAccordion = false,
}) => {
  const getInitials = (name) => {
    if (!name) return "";
    return name
      .split(" ")
      .slice(0, 2)
      .map((e) => e.at(0))
      .join("")
      .toUpperCase();
  };

  return (
    <Accordion defaultActiveKey={defaultActiveKey}>
      {React.Children.map(children, (child, index) => {
        const hasContent = child.props.children && React.Children.count(child.props.children) > 0;

        return (
          <Accordion.Item eventKey={hasContent ? index.toString() : undefined}>
            <Accordion.Header
              onClick={(e) => {
                if (!hasContent) e.stopPropagation();
              }}
              className={!haveMoreDropdown ? "no-arrow" : ""}
            >
              <div className="d-flex justify-content-between w-100">
                <span className="d-flex align-items-center gap-1">
                  {checkbox && <span onClick={(e) => e.stopPropagation()}>{checkbox}</span>}
                  <span>
                    {avatar ? (
                      <img
                        src={avatar}
                        alt="Avatar"
                        className="rounded-circle smallavatar"
                        onError={(e) => {
                          e.target.style.display = "none"; // Hide the image on error
                          e.target.insertAdjacentHTML(
                            "afterend",
                            `<span class="avatar-fallback">${getInitials(child.props.heading)}</span>`
                          );
                        }}
                        style={{ width: 30, height: 30 }}
                      />
                    ) : (
                      <span className="avatar-fallback">{getInitials(child.props.heading)}</span>
                    )}
                    {child.props.heading}
                  </span>
                </span>
                {button && (
                  <span onClick={(e) => e.stopPropagation()} className="ms-auto">
                    {button}
                  </span>
                )}
              </div>
            </Accordion.Header>
            {hasContent ? <Accordion.Body>{child.props.children}</Accordion.Body> : null}
          </Accordion.Item>
        );
      })}
    </Accordion>
  );
};

export default SimAccordion;
